import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { lastValueFrom } from 'rxjs';
import { projectPath } from '../../../cross-team-shared/hub-paths';
import { WorkspaceConfigService } from '../../../shared/misc-services/workspace-config.service';
import { JsonOutput } from '../../../team-apis/otterdam/outputs/json-output';
import { Project } from '../../../team-apis/otterdam/project';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { AbstractResource } from '../abstract-resource';

export const mockGenAiOutputId = 666;
export const mockGenAiOutputName = 'genai';

@Injectable()
export class ProjectLoadingService extends AbstractResource {
  private workspaceConfigService = inject(WorkspaceConfigService);
  private taskWorkspaceStore = inject(TaskWorkspaceStore);

  async load() {
    const { projectId } = this.workspaceConfigService;

    const token = await this.getToken('access_token', true);

    const project = await lastValueFrom(
      this.request$<Project>(
        'GET',
        `${environment.sh3BaseUrl}${projectPath(projectId)}`,
        {
          cache: true,
          customErrorMessage: 'Failed to load project.',
          headers: { Authorization: `Bearer ${token}` },
        },
      ),
    );

    if (project.outputs.length === 0) {
      this.addMockGenAiOutput(project);
    }

    this.taskWorkspaceStore.setProject(project);
  }

  private addMockGenAiOutput(project: Project) {
    const mockGenAiOutput: JsonOutput = {
      type: 'JsonOutput',
      id: mockGenAiOutputId,
      name: mockGenAiOutputName,
      required: false,
      error_tags: [],
      project_id: project.id,
    };
    project.outputs.push(mockGenAiOutput);
  }
}
